// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__IPjkD","content":"styles_content__2OfuT","checkbox":"styles_checkbox__30awk","checkboxLabel":"styles_checkboxLabel__scqVl"};